import { useGetSiteFlagsQuery } from '@store/api/siteApi'

/** True while paid tiers should be hidden. Defaults to beta if the flag is still loading. */
export function useBetaMode(): { beta: boolean; isLoading: boolean } {
  const { data, isLoading, isError } = useGetSiteFlagsQuery()
  if (isLoading) return { beta: true, isLoading: true }
  if (isError || !data) return { beta: true, isLoading: false }
  return { beta: data.beta, isLoading: false }
}
